/**
 *
 * DashboardHome
 *
 */

import { connect, ConnectedProps } from "react-redux";
import { compose } from "redux";
import { injectReducer, injectSaga, SagaInjectionModes } from "redux-injectors";
import { Dispatch, SetStateAction } from "react";

import { UserInfo } from "types/UserInfo";
import withAuth from "utils/withAuth";
import Layout from "./layout";
import selectDashboardDataProps from "./selectors";

import reducer, { actionProps } from "./redux";
import saga from "./saga";

type OwnProps = {
  setLoading?: Dispatch<SetStateAction<boolean>>;
};

const mapStateToProps = selectDashboardDataProps;
const mapDispatchToProps = actionProps;

const withConnect = connect<
  ReturnType<typeof mapStateToProps>,
  ReturnType<typeof mapDispatchToProps>,
  OwnProps
>(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: "dashboard", reducer });
const withSaga = injectSaga({
  key: "dashboard",
  saga,
  mode: SagaInjectionModes.RESTART_ON_REMOUNT,
});

export default compose(
  withConnect,
  withReducer,
  withSaga,
  withAuth({ route: `${window.location.origin}/dashboard/home` })
)(
  Layout as React.ComponentType<
    ConnectedProps<typeof withConnect & { userInfo: UserInfo } & OwnProps>
  >
);
